export default __webpack_public_path__ + "static/media/java.29281a7b.svg";